import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] animate-fade-in">
      <style>
        {`
          @keyframes fade-in {
            from { opacity: 0; transform: translateY(30px);}
            to { opacity: 1; transform: translateY(0);}
          }
          .animate-fade-in {
            animation: fade-in 0.7s cubic-bezier(.4,0,.2,1);
          }
        `}
      </style>
      <div className="text-6xl font-extrabold text-yellow-400 mb-2 drop-shadow-lg">404</div>
      <div className="text-2xl font-bold text-gray-100 mb-2">Page Not Found</div>
      <div className="text-gray-400 text-center mb-8 max-w-md">
        The page you're looking for has gone on vacation.<br />
        It might return someday, but for now, let's get you back on track.
      </div>
      <div className="flex gap-4">
        <button
          className="bg-yellow-400 text-gray-900 px-6 py-2 rounded-lg font-semibold shadow hover:bg-yellow-300 transition flex items-center gap-2"
          onClick={() => navigate('/')}
        >
          <span>&larr;</span> Return Home
        </button>
        <button
          className="bg-gray-800 text-gray-100 px-6 py-2 rounded-lg font-semibold shadow hover:bg-gray-700 transition flex items-center gap-2 border border-gray-700"
          onClick={() => navigate(-1)}
        >
          <span>&larr;</span> Go Back
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;